import appRuleDialogReducer from './appRuleDialogReducer';

export default appRuleDialogReducer;